module.exports = __webpack_public_path__ + "img/90sheji_linggan_13134065@2x.f8343288.png";